const allowableBusinessTypeSlugs = [
    'food_truck_concession',
    'Food Truck/Concession',
    'Other Services',
];
const bodyEl = document.querySelector('body');

const isSelectionEligibleForResellingLeads = (form: HTMLFormElement): boolean => {
    const consentSectionEl = form.querySelector<HTMLElement>(
        '[data-form-consent-section]'
    );
    if (!consentSectionEl) return false;

    const businessTypeField =
        form.querySelector<HTMLSelectElement>(
            'select[name=business_type], select[name=resto_business_type], select[name=agnostic_business_type]'
        ) || form.querySelector<HTMLInputElement>('input[name=business_type_slug]');
    const secondaryBusinessTypeField = form.querySelector<
        HTMLInputElement | HTMLSelectElement
    >('input[name=secondary_business_type], select[name=secondary_business_type]');
    if (
        allowableBusinessTypeSlugs.includes(businessTypeField?.value ?? '') ||
        (businessTypeField?.value.toLowerCase() === 'services' &&
            allowableBusinessTypeSlugs.includes(secondaryBusinessTypeField?.value ?? ''))
    ) {
        return true;
    }

    return false;
};

const showConsentLightboxPanel = (form: HTMLFormElement) => {
    const progressIndicatorContainer = form.querySelector<HTMLElement>(
        '[data-progress-indicator]'
    );
    const currentPanel = form.querySelector<HTMLElement>('[data-wizard-show-panel=true]');
    const consentPanel = form.querySelector<HTMLElement>(
        '[data-wizard-panel-slug=consent]'
    );
    if (progressIndicatorContainer && currentPanel && consentPanel) {
        progressIndicatorContainer.style.display = 'none';
        currentPanel.dataset.wizardShowPanel = 'false';
        consentPanel.dataset.wizardShowPanel = 'true';
    }
};

const showConsentModal = (form: HTMLFormElement) => {
    const consentSectionWrapper = form.querySelector<HTMLElement>(
        '[data-form-consent-section-inline-wrapper]'
    );
    bodyEl?.classList.add('tw:overflow-hidden');
    consentSectionWrapper?.classList.replace('gb-hide', 'gb-flex');
    consentSectionWrapper?.classList.replace(
        'tw:animate-fade-out-fast',
        'tw:animate-fade-in-fast'
    );
};

const handleResellingLeadsIntervention = (form: HTMLFormElement) => {
    if (form.dataset.formName?.includes('lightbox')) {
        showConsentLightboxPanel(form);
        return;
    }
    showConsentModal(form);
};

const initializeConsentPanelElements = (form: HTMLFormElement) => {
    const consentPanelSubmitButtons: HTMLButtonElement[] = Array.from(
        form.querySelectorAll('[data-form-partner-resell-consent]')
    );
    consentPanelSubmitButtons.forEach(consentButton => {
        consentButton.addEventListener('click', e => {
            if (e.currentTarget instanceof HTMLButtonElement) {
                e.preventDefault();
                bodyEl?.classList.remove('tw:overflow-hidden');
                const hiddenFieldContainer = form?.querySelector<HTMLElement>(
                    '[data-form=hidden-field-container]'
                );
                const consentValue =
                    e.currentTarget.dataset.formPartnerResellConsent === 'true'
                        ? 'true'
                        : 'false';
                const resellContentHiddenField = document.createElement('input');
                resellContentHiddenField.type = 'hidden';
                resellContentHiddenField.name = 'partner_resell_consent';
                resellContentHiddenField.value = consentValue;
                hiddenFieldContainer?.appendChild(resellContentHiddenField);

                if (form) {
                    form.dispatchEvent(
                        new Event('submit', { bubbles: true, cancelable: true })
                    );
                }
            }
        });
    });

    const consentModalWrapper = form.querySelector<HTMLElement>(
        '[data-form-consent-section-inline-wrapper]'
    );
    const consentModalCloseButton: HTMLButtonElement | null | undefined =
        consentModalWrapper?.querySelector('[data-consent-close-button]');

    consentModalCloseButton?.addEventListener('click', () => {
        bodyEl?.classList.remove('tw:overflow-hidden');
        consentModalWrapper?.classList.replace(
            'tw:animate-fade-in-fast',
            'tw:animate-fade-out-fast'
        );
    });
    consentModalWrapper?.addEventListener('animationend', e => {
        if (e.animationName === 'fade-out') {
            consentModalWrapper?.classList.replace('gb-flex', 'gb-hide');
        }
    });
};

export {
    isSelectionEligibleForResellingLeads,
    handleResellingLeadsIntervention,
    initializeConsentPanelElements,
};
